import React from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '@store/hooks';
import { Popover, Modal, Button } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import './FeedBack.scss';
import { getMeetingInfoInput } from '@store/meeting/meeting.slice';
import { execCommandCopy, getBrowserInfo } from '@utils/browser';
import { openToast } from '@component/toast';

const FeedBack: React.FC = () => {
  const { t } = useTranslation();
  const meeting = useAppSelector(getMeetingInfoInput);

  const onFeedBackClick = () => {
    const browserInfo = getBrowserInfo();
    const conentInfoBody = `
        ${t('问题描述：')}%0D

        %0D

        ${t('会议基本信息：')}%0D
        ${t('会议 ID：')}${meeting.meetingCode}%0D
        ${t('用户昵称：')}${meeting.nickname}%0D
        ${t('问题发生时间：')}${dayjs().format('YYYY/MM/DD HH:mm:ss')}%0D
        ${t('浏览器版本：')}${browserInfo}%0D`;

    const modal = Modal.show({
      caption: <div>{t('意见反馈')}</div>,
      className: 'feed-back-modal',
      children: (
        <div>
          <div className="feed-back-modal__title">
            {t('感谢您的使用。请复制反馈信息，然后通过邮箱发送到：')}
            <a
              href={`mailto:info@voovmeeting.com?subject=${t('[web 入会]问题反馈')}&body=${conentInfoBody}`}
              target="_blank"
              rel="noreferrer"
            >
              info@voovmeeting.com
            </a>
          </div>
          <div className="feed-back-modal__cont">
            <div>
              <div className="feed-back-modal__cont__desc">{t('问题描述：')}</div>
              <div className="feed-back-modal__cont__info">
                <div className="feed-back-modal__cont__info__title">{t('会议基本信息：')}</div>
                <div className="feed-back-modal__cont__info__list">
                  <div>
                    {t('会议 ID：')}
                    {meeting.meetingCode}
                  </div>
                  <div>
                    {t('用户昵称：')}
                    {meeting.nickname}
                  </div>
                  <div>
                    {t('问题发生时间：')}
                    {dayjs().format('YYYY/MM/DD HH:mm:ss')}
                  </div>
                  <div>
                    {t('浏览器版本：')}
                    {browserInfo}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="feed-back-modal__footer">
            <Button
              type="primary"
              onClick={() => {
                execCommandCopy(conentInfoBody);
                openToast(t('复制反馈信息成功'));
                window.open(
                  `mailto:info@voovmeeting.com?subject=${t('[web 入会]问题反馈')}&body=${conentInfoBody}`,
                  '_blank',
                );
              }}
            >
              {t('复制反馈信息')}
            </Button>
          </div>
        </div>
      ),
      onClose: () => modal.destroy(),
    });
  };
  return (
    <Popover placement="bottom" overlay={t('我要反馈')} overlayClassName="feed-back-popover">
      <div className="feed-back" onClick={onFeedBackClick} />
    </Popover>
  );
};

export default FeedBack;
